{
    "UserRoleLabel": "Função:",
    "RoleCustomLabel": "Personalizado",
    "RoleRequiresReportingLevel": "A função de usuários requer acesso a relatórios",
    "RoleRequiresNoReportingLevel": "A função de usuários não requer acesso a relatórios",
    "RolePermissionsTooLow": "Você não tem permissões altas o suficiente para editar este usuário. Fale com um administrador para aumentar suas permissões e permitir que você edite este usuário.",
    "RoleReportingGroup": "FUNÇÕES DE RELATÓRIO",
    "RoleAdminGroup": "FUNÇÕES DO ADMINISTRADOR",
    "NONE": "[None]",
    "REPORTING_USER": "Reportando apenas usuário",
    "ADVANCED_REPORTING_USER": "Usuário de relatórios avançados",
    "END_USER_ADMIN": "Apenas usuário final",
    "CUSTOM": "Personalizado",
    "SUPER_ADMIN": "Administrador completo",
    "RESELLER_ADMIN": "Revendedor",
    "TELEPHONY_SERVER_ADMIN": "Revendedor - SP",
    "PARTITION_ADMIN": "Revendedor - Site",
    "SUPPORT": "Apoiar",
    "VIEW": "Administrador completo (somente leitura)",
    "BILLING_SUPPORT": "Cobrança",
    "END_USER_PROVISIONING": "Provisionamento",
    "SELF_PROVISIONER": "Provisionamento empresarial",
    "Role:NONE": "Nenhuma função foi atribuída, este usuário terá as permissões padrão",
    "Role:REPORTING_USER": "Uma função com nível de acesso de relatório e permissões padrão",
    "Role:ADVANCED_REPORTING_USER": "Supervisor com acesso a relatórios e algumas ações avançadas de administrador",
    "Role:END_USER_ADMIN": "Administrador apenas com ações avançadas e sem acesso a relatórios",
    "Role:CUSTOM": "Uma função personalizada com permissões atribuídas conforme necessário",
    "Role:SUPER_ADMIN": "Administrador com direitos totais de administrador (e pode ter acesso opcional a relatórios)",
    "Role:RESELLER_ADMIN": "Administrador com direitos totais de administrador, exceto para alterar o nível de licença (e pode ter acesso opcional a relatórios)",
    "Role:TELEPHONY_SERVER_ADMIN": "Administrador com direitos totais de administrador até o nível de telefonia (e pode ter acesso opcional a relatórios)",
    "Role:PARTITION_ADMIN": "Administrador com direitos totais de administrador até o nível de partição (e pode ter acesso opcional a relatórios)",
    "Role:SUPPORT": "Administrador com direitos de administrador técnico e (e pode ter acesso opcional a relatórios)",
    "Role:VIEW": "Administrador que pode apenas visualizar (e pode ter acesso opcional a relatórios)",
    "Role:BILLING_SUPPORT": "Administrador com acesso somente de visualização, mas tem a capacidade de baixar CDRs e ver logs de auditoria (e pode ter acesso opcional a relatórios)",
    "Role:END_USER_PROVISIONING": "Administrador com capacidade de provisionar apenas adicionando e modificando (e pode ter acesso opcional a relatórios)",
    "Role:SELF_PROVISIONER": "Administrador com capacidade de provisionar usando o assistente de provisionamento (e pode ter acesso opcional a relatórios)",
    "NAME": "RoleLanguage",
    "UserCustomizedRoles": "MODELOS DE FUNÇÕES PERSONALIZADOS",
    "CreateCustomRole": "Adicionar modelo de função personalizado",
    "DeleteCustomRole": "Eliminar modelo de função personalizada",
    "USER_MANAGER": "Gestor de utilizadores",
    "Role:USER_MANAGER": "Para gerir utilizadores através do pop-up Gestão de utilizadores.",
    "Role:TEAMS_PROVISIONING": "Administrador com capacidade para autorizar e gerir servidores de telefonia"
}